import React from 'react';

import { MicTestButton } from '../../../components';

function Info() {
  return (
    <div>
      <p>
        <em>
          Per CMS guidelines a telephonic enrollment must be initiated by the shopper.
          Therefore please instruct the shopper to call the following phone number to
          initiate the telephonic enrollment. The call will connect through this system.
        </em>
      </p>

      <p>
        <em>
          You may send a text or email with your contact information directly to the shopper.
        </em>
      </p>

      <p>
        <em>
          Before you continue, please be sure you have your PC microphone and speaker / headset
          ready. You can test your headset by clicking on &apos;test headset.&apos; Note, shoppers
          will share Personal Health Information, so we recommend using a headset to ensure
          the shopper&apos;s privacy.
        </em>
      </p>

      <p>
        <MicTestButton />
      </p>

      <p className="text-danger">
        <em>
          Be sure to read through the script before continuing
        </em>
      </p>

    </div>
  );
}

export default Info;
